var Mt = Object.defineProperty, At = Object.defineProperties;
var Dt = Object.getOwnPropertyDescriptors;
var pt = Object.getOwnPropertySymbols;
var Lt = Object.prototype.hasOwnProperty, It = Object.prototype.propertyIsEnumerable;
var mt = (r, t, e) => t in r ? Mt(r, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : r[t] = e, b = (r, t) => {
  for (var e in t || (t = {}))
    Lt.call(t, e) && mt(r, e, t[e]);
  if (pt)
    for (var e of pt(t))
      It.call(t, e) && mt(r, e, t[e]);
  return r;
}, I = (r, t) => At(r, Dt(t));
import { createNamespacedHelpers as Bt } from "vuex";
const W = {
  computed: {
    isMobileView() {
      var r, t;
      return (t = (r = this.$store) == null ? void 0 : r.getters["layout/IS_MOBILE"]) != null ? t : this.isMobile;
    },
    isNuxt() {
      return !!this.$nuxt;
    }
  }
};
function k(r, t, e, s, i, d, h, y) {
  var u = typeof r == "function" ? r.options : r;
  t && (u.render = t, u.staticRenderFns = e, u._compiled = !0), s && (u.functional = !0), d && (u._scopeId = "data-v-" + d);
  var v;
  if (h ? (v = function(_) {
    _ = _ || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !_ && typeof __VUE_SSR_CONTEXT__ != "undefined" && (_ = __VUE_SSR_CONTEXT__), i && i.call(this, _), _ && _._registeredComponents && _._registeredComponents.add(h);
  }, u._ssrRegister = v) : i && (v = y ? function() {
    i.call(
      this,
      (u.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : i), v)
    if (u.functional) {
      u._injectStyles = v;
      var N = u.render;
      u.render = function($, w) {
        return v.call(w), N($, w);
      };
    } else {
      var A = u.beforeCreate;
      u.beforeCreate = A ? [].concat(A, v) : [v];
    }
  return {
    exports: r,
    options: u
  };
}
const Nt = {
  name: "CustomNuxtLink",
  mixins: [W],
  props: {
    to: {
      type: String,
      default: "/"
    },
    nuxt: {
      type: Boolean,
      default: !1
    },
    replace: {
      type: Boolean,
      default: !1
    },
    target: {
      type: String,
      default: "_self"
    },
    external: {
      type: Boolean,
      default: !1
    },
    baseUrl: {
      type: String,
      default: ""
    }
  },
  computed: {
    withBaseUrl() {
      return this.external ? this.to : `${this.baseUrl}${this.to}`;
    }
  }
};
var Ht = function() {
  var t = this, e = t._self._c;
  return t.isNuxt && t.nuxt && t.target !== "_blank" ? e("nuxt-link", t._g(t._b({ attrs: { to: t.to, replace: t.replace } }, "nuxt-link", t.$attrs, !1), t.$listeners), [t._t("default")], 2) : e("a", t._g(t._b({ attrs: { href: t.withBaseUrl, target: t.target } }, "a", t.$attrs, !1), t.$listeners), [t._t("default")], 2);
}, Et = [], Ot = /* @__PURE__ */ k(
  Nt,
  Ht,
  Et,
  !1,
  null,
  "236c8375",
  null,
  null
);
const q = Ot.exports, Rt = [
  {
    name: "커뮤니티",
    path: "/job-questions",
    nuxt: !0
  },
  {
    name: "클래스",
    path: "/edu",
    nuxt: !1
  },
  {
    name: "채용",
    path: "/career/dreamverse",
    nuxt: !0
  }
], Tt = [
  {
    path: "/search/index",
    name: "통합",
    product: "index",
    active: !1,
    anchor: !0
  },
  {
    path: "/search/community",
    name: "커뮤니티",
    product: "community",
    active: !1,
    anchor: !0
  },
  {
    path: "/search/edu",
    name: "직무부트캠프",
    product: "edu",
    active: !1,
    anchor: !0
  },
  {
    path: "/search/pt",
    name: "실무VOD",
    product: "pt",
    active: !1,
    anchor: !0
  },
  {
    path: "/search/vod",
    name: "직무VOD",
    product: "vod",
    active: !1,
    anchor: !0
  },
  {
    path: "/search/answer",
    name: "답변하기",
    product: "answer",
    active: !1
  }
], Pt = [
  {
    path: "/job-questions",
    name: "타임라인",
    active: !1
  },
  {
    path: "/job-questions?feed=recent",
    name: "Q&A",
    active: !1
  },
  {
    path: "/job-wiki",
    name: "직무소개",
    active: !1,
    anchor: !0
  },
  {
    path: "/answer",
    name: "답변하기",
    active: !1
  }
], Ut = [
  {
    path: "/edu",
    name: "직무부트캠프",
    active: !1,
    anchor: !0
  },
  {
    path: "/kdigital",
    name: "국비지원",
    active: !1,
    anchor: !0
  },
  {
    path: "/class/pt/list",
    name: "실무VOD",
    active: !1
  },
  {
    path: "/edu/path/list",
    name: "진로부트캠프",
    active: !1
  },
  {
    path: "/vod",
    name: "직무VOD",
    active: !1
  },
  {
    path: "/class/training",
    name: "양성과정",
    active: !1
  }
], Kt = {
  path: "http://xn--289a58egsh8xehnra748w.com/",
  name: "미래내일일경험",
  active: !1
}, Ft = [
  { path: "/career/dreamverse", name: "인턴십", active: !1 },
  { path: "/career/recruit", name: "공고", active: !1 }
], Y = {
  JOB_QUESTIONS: "job-questions-keyword",
  JOB_WIKI: "job-wiki",
  ANSWER: "answer",
  EDU: "edu",
  CLASS_PT: "class-pt",
  VOD: "vod",
  CLASS_VOD: "class-vod",
  COMMUNITY_LOUNGE: "community-lounge",
  SEARCH_LIST: "search-product-keyword",
  EDU_PATH: "edu-path",
  CLASS: "class",
  INDEX: "index",
  CAREER_EXTERNSHIP: "career-externship"
}, lt = {
  LOUNGE: "/community/lounge",
  SEARCH: "/search",
  ANSWER: "/answer"
}, M = {
  INDEX: "index",
  COMMUNITY: "community",
  EDU: "edu",
  CLASS_PT: "pt",
  VOD: "vod",
  ANSWER: "answer",
  JOB_WIKI: "job-wiki"
}, rt = {
  RELEVANCE: "relevance",
  RECENT: "recent",
  POPULAR: "popular",
  COMMENTS: "comments",
  COMMENTS_FEW: "comments_few"
}, ft = {
  DEFAULT: "default",
  BACKWARD: "backward",
  LOGO: "logo"
}, yt = {
  SEARCH: "search",
  BOOKMARK: "bookmark",
  NOTIFICATION: "notification"
}, vt = "https://comento-ad.oopy.io/", Vt = [
  {
    label: "제휴관리자",
    to: "https://www.partners.comento.kr",
    external: !0
  },
  {
    label: "기업교육",
    to: "https://edu.potens.ai",
    external: !0
  }
], Wt = "실무VOD";
const jt = {
  name: "SlimFooter",
  mixins: [W],
  created() {
    this.AD_INQUIRY_URL = vt;
  },
  components: { CustomNuxtLink: q }
};
var Yt = function() {
  var t = this, e = t._self._c;
  return e("footer", { directives: [{ name: "show", rawName: "v-show", value: !t.isMobileView, expression: "!isMobileView" }] }, [e("c-new-grid", [e("c-new-row", [e("c-new-col", [e("div", { staticClass: "footer-main" }, [e("c-typography", { attrs: { type: "caption2", color: "gray600", "font-weight": 600 } }, [t._v("(주)코멘토")]), e("details", { staticClass: "ml-4" }, [e("summary", { staticClass: "flex align-center" }, [e("c-typography", { attrs: { type: "caption2", color: "gray600" } }, [t._v(" 사업자 정보")]), e("c-icon", { staticClass: "ml-4", attrs: { name: "IconArrowXSmallLine", color: "gray600" } })], 1), e("div", { staticClass: "footer-details" }, [e("div", { staticClass: "flex" }, [e("c-typography", { attrs: { type: "caption2", color: "gray600" } }, [t._v(" 대표 : 이재성 04512 서울특별시 중구 칠패로 28, 메리츠강북타워 3층 ")]), e("c-typography", { staticClass: "ml-16", attrs: { type: "caption2", color: "gray600" } }, [t._v(" 사업자 등록번호 : 487-86-00195 ")]), e("c-typography", { staticClass: "ml-16", attrs: { type: "caption2", color: "gray600" } }, [t._v(" 통신판매업 신고번호 : 제 2018-서울중구-1245호 ")]), e("c-typography", { staticClass: "ml-16", attrs: { type: "caption2", color: "gray600" } }, [t._v(" 직업정보제공 사업신고 : 서울청 제 2018-19호 ")]), e("c-typography", { staticClass: "ml-16", attrs: { type: "caption2", color: "gray600" } }, [t._v(" 원격평생교육시설신고 : 제 원격-376호 ")])], 1), e("div", { staticClass: "flex my-4" }, [e("c-typography", { attrs: { type: "caption2", color: "gray600" } }, [t._v(" 유료직업소개사업 등록번호 제 2022-3010165-14-5-00021호 ")]), e("c-typography", { staticClass: "ml-16", attrs: { type: "caption2", color: "gray600" } }, [t._v(" 유선번호 : 070-4154-0804 ")])], 1), e("c-typography", { attrs: { type: "caption2", color: "gray600" } }, [t._v(" Copyright by (주)코멘토. All right reserved. ")])], 1)]), e("c-divider", { staticClass: "mx-12", staticStyle: { height: "8px" }, attrs: { vertical: "", color: "gray200" } }), e("ul", { staticClass: "flex" }, [e("li", [e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/notice" } }, [e("c-typography", { attrs: { type: "caption2", color: "gray600" } }, [t._v(" 공지사항")])], 1)], 1), e("li", { staticClass: "ml-12" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, external: "", to: "https://edu.potens.ai" } }, [e("c-typography", { attrs: { type: "caption2", color: "gray600" } }, [t._v(" 기업교육")])], 1)], 1), e("li", { staticClass: "ml-12" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/affiliated-university" } }, [e("c-typography", { attrs: { type: "caption2", color: "gray600" } }, [t._v(" 제휴 대학 인증")])], 1)], 1), e("li", { staticClass: "ml-12" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/help" } }, [e("c-typography", { attrs: { type: "caption2", color: "gray600" } }, [t._v(" 고객센터")])], 1)], 1), e("li", { staticClass: "ml-12" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, to: t.AD_INQUIRY_URL } }, [e("c-typography", { attrs: { type: "caption2", color: "gray600" } }, [t._v(" 광고문의")])], 1)], 1), e("li", { staticClass: "ml-12" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/agreement" } }, [e("c-typography", { attrs: { type: "caption2", color: "gray600" } }, [t._v(" 이용약관")])], 1)], 1), e("li", { staticClass: "ml-12" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/agreement" } }, [e("c-typography", { attrs: { type: "caption2", color: "gray600", "font-weight": 600 } }, [t._v(" 개인정보처리방침 ")])], 1)], 1)]), e("c-logo", { staticClass: "ml-auto", attrs: { width: "55.03", height: "8.85", color: "gray300", url: "#none" } })], 1)])], 1)], 1)], 1);
}, zt = [], qt = /* @__PURE__ */ k(
  jt,
  Yt,
  zt,
  !1,
  null,
  "e102a46e",
  null,
  null
);
const Jt = qt.exports;
function ht(r) {
  const t = /[^\wㄱ-힣()0-9]/gi;
  return r == null ? void 0 : r.replace(new RegExp(t), (e) => encodeURIComponent(e));
}
function Qt(r, t) {
  let e = String(r), s = 0;
  for (let i = 0; i < e.length; i++)
    if (!(e.charCodeAt(i) === 32) && s < t && s++, s >= t) {
      e = e.substring(0, i);
      break;
    }
  return e;
}
function _t(r) {
  return r === null || typeof r == "undefined" || typeof r == "string" && r === "" || Array.isArray(r) && r.length < 1 || typeof r == "object" && r.constructor.name === "Object" && Object.keys(r).length < 1 && Object.getOwnPropertyNames(r) < 1 || typeof r == "object" && r.constructor.name === "String" && Object.keys(r).length < 1;
}
const { mapGetters: J, mapMutations: cs, mapActions: X } = Bt("_commonComponents"), Gt = {
  namespaced: !0,
  state: () => ({
    user: {
      name: ""
    },
    domain: "https://comento.kr",
    keywords: {
      autocomplete: [],
      recent: [],
      popular: [],
      search: ""
    },
    count: {
      bookmark: 0,
      notification: 0
    },
    topBar: {
      type: ft.DEFAULT,
      title: "",
      actions: null
    },
    isWithAlert: !1,
    header: {
      transparent: !1
    },
    isSubHeaderAppear: !1
  }),
  getters: {
    user: (r) => r.user,
    domain: (r) => r.domain,
    count: (r) => r.count,
    keywords: (r) => r.keywords,
    topBar: (r) => {
      let t;
      const { DEFAULT: e, BACKWARD: s, LOGO: i } = ft, { SEARCH: d, BOOKMARK: h, NOTIFICATION: y } = yt, u = {
        [e]: [d, h, y],
        [s]: [],
        [i]: [d]
      };
      return r.topBar.actions === null ? t = u[r.topBar.type] : t = r.topBar.actions, I(b({}, r.topBar), {
        actions: t
      });
    },
    isWithAlert: (r) => r.isWithAlert,
    header: (r) => r.header,
    isSubHeaderAppear: (r) => r.isSubHeaderAppear
  },
  mutations: {
    setUser: (r, t) => r.user = t,
    setDomain: (r, t) => r.domain = t,
    setCount: (r, t) => r.count = t,
    setKeywords: (r, t) => {
      r.keywords = I(b({}, t), {
        search: Qt(t.search, 50)
      });
    },
    setTopBar: (r, t) => r.topBar = t,
    setWithAlert: (r, t) => r.isWithAlert = t,
    setHeader: (r, t) => r.header = t,
    setIsSubHeaderAppear: (r, t) => r.isSubHeaderAppear = t
  },
  actions: {
    syncProps({ commit: r }, t) {
      r("setUser", t.userInfo), r("setDomain", t.baseUrl), r("setCount", {
        bookmark: t.bookmarkCount,
        notification: t.notificationCount
      }), r("setKeywords", {
        autocomplete: t.autocompleteList,
        recent: t.recentKeyword,
        popular: t.popularKeyword,
        search: t.searchKeyword
      }), r("setTopBar", {
        type: t.topBarType,
        title: t.topBarTitle,
        actions: t.topBarActions
      }), r("setWithAlert", t.withAlert), r("setHeader", {
        transparent: t.isTransparent
      });
    },
    logout() {
    },
    clickNoti() {
    },
    removeRecentKeyword() {
    },
    search() {
    },
    openSearch() {
    }
  }
};
function us(r) {
  r.registerModule(["_commonComponents"], Gt);
}
const Zt = {
  name: "FooterServiceSection",
  mixins: [W],
  props: {
    baseUrl: {
      type: String,
      default: ""
    }
  },
  computed: {
    sectionStyles() {
      return {
        display: "flex",
        "flex-direction": "column",
        "justify-content": "space-between",
        width: `${this.isMobileView ? "100%" : "280px"}`,
        height: `${this.isMobileView ? 173 : 184}px`
      };
    }
  },
  components: { CustomNuxtLink: q }
};
var Xt = function() {
  var t = this, e = t._self._c;
  return e("section", { style: t.sectionStyles }, [e("div", [e("c-typography", { attrs: { type: "body2", color: "gray850", element: "h2", "font-weight": 600 } }, [t._v(" 고객센터 ")]), e("c-typography", { staticClass: "mt-20", attrs: { color: "gray600", type: "caption1" } }, [t._v(" 운영시간 : 평일 10시 ~ 18시 30분 (주말, 공휴일 제외)"), e("br"), t._v(" 점심시간 : 12시 30분 ~ 14시"), e("br"), e("br"), t._v(" 기업 제휴 문의: help@comento.kr ")])], 1), e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/help", "base-url": t.baseUrl } }, [e("c-button", { attrs: { color: "info", type: "outline", full: "" }, scopedSlots: t._u([{ key: "left-icon", fn: function() {
    return [e("c-icon", { attrs: { name: "IconSupportSmallLine", color: "gray600" } })];
  }, proxy: !0 }]) }, [t._v(" 1:1 문의하기 ")])], 1)], 1);
}, te = [], ee = /* @__PURE__ */ k(
  Zt,
  Xt,
  te,
  !1,
  null,
  "7520814c",
  null,
  null
);
const re = ee.exports;
const se = {
  name: "FooterProductSection",
  mixins: [W],
  props: {
    baseUrl: {
      type: String,
      default: ""
    }
  },
  created() {
    this.AD_INQUIRY_URL = vt;
  },
  components: { CustomNuxtLink: q }
};
var oe = function() {
  var t = this, e = t._self._c;
  return e("section", { staticClass: "footer-services", class: { mobile: t.isMobileView } }, [e("div", { class: { "mr-42": t.isMobileView }, style: { width: t.isMobileView ? "136px" : "100%" } }, [e("c-typography", { attrs: { type: "body2", color: "gray850", "font-weight": 600 } }, [t._v(" 서비스")]), e("div", { staticClass: "footer-service-container-by-category" }, [e("div", { staticClass: "footer-service-item" }, [e("CustomNuxtLink", { attrs: { nuxt: "", to: "/comento" } }, [e("c-typography", { attrs: { type: "caption1", color: "gray600" } }, [t._v("회사소개")])], 1)], 1), e("div", { staticClass: "footer-service-item" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/notice", "base-url": t.baseUrl } }, [e("c-typography", { attrs: { type: "caption1", color: "gray600" } }, [t._v("공지사항")])], 1)], 1), e("div", { staticClass: "footer-service-item" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, external: "", to: "https://comento.notion.site/a6dee5a37a5448d0b7315a80a985ebf2", target: "_blank" } }, [e("c-typography", { attrs: { type: "caption1", color: "gray600" } }, [t._v("인재 채용")])], 1)], 1), e("div", { staticClass: "footer-service-item" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/affiliated-university", "base-url": t.baseUrl } }, [e("c-typography", { attrs: { type: "caption1", color: "gray600" } }, [t._v("제휴 대학 인증")])], 1)], 1)])], 1), e("div", { style: { width: t.isMobileView ? "154px" : "100%" } }, [e("c-typography", { attrs: { type: "body2", color: "gray850", "font-weight": 600 } }, [t._v(" 파트너스")]), e("div", { staticClass: "footer-service-container-by-category" }, [e("div", { staticClass: "footer-service-item" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, external: "", to: "https://partners.comento.kr", target: "_blank" } }, [e("c-typography", { attrs: { type: "caption1", color: "gray600" } }, [t._v("제휴 관리자")])], 1)], 1), e("div", { staticClass: "footer-service-item" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/product/learn", "base-url": t.baseUrl } }, [e("c-typography", { attrs: { type: "caption1", color: "gray600" } }, [t._v("직무부트캠프 제휴")])], 1)], 1), e("div", { staticClass: "footer-service-item" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/product/mentoring", "base-url": t.baseUrl } }, [e("c-typography", { attrs: { type: "caption1", color: "gray600" } }, [t._v("멘토링 제휴")])], 1)], 1), e("div", { staticClass: "footer-service-item" }, [e("CustomNuxtLink", { attrs: { to: t.AD_INQUIRY_URL } }, [e("c-typography", { attrs: { type: "caption1", color: "gray600" } }, [t._v("광고문의")])], 1)], 1), e("div", { staticClass: "footer-service-item" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, external: "", to: "https://edu.potens.ai" } }, [e("c-typography", { attrs: { type: "caption1", color: "gray600" } }, [t._v("기업 교육")])], 1)], 1)])], 1)]);
}, ne = [], ae = /* @__PURE__ */ k(
  se,
  oe,
  ne,
  !1,
  null,
  "647c5e3d",
  null,
  null
);
const ie = ae.exports;
const ce = {
  name: "FooterAppDownloadBadges",
  data() {
    return {
      isAndroid: !1,
      badges: [
        {
          id: "iOS",
          altText: "App Store에서 다운로드 하기",
          href: "https://apps.apple.com/kr/app/id1564376157",
          src: "https://cdn.comento.kr/images/app/app-store-badge.svg"
        },
        {
          id: "Android",
          altText: "Google Play에서 다운로드",
          href: "https://play.google.com/store/apps/details?id=kr.comento.core",
          src: "https://cdn.comento.kr/images/app/google-play-badge.svg"
        }
      ]
    };
  },
  computed: {
    badgesByOs() {
      return this.isAndroid ? [this.badges[1], this.badges[0]] : this.badges;
    }
  },
  mounted() {
    this.isAndroid = this.checkIfAndroid();
  },
  methods: {
    checkIfAndroid() {
      return navigator.userAgent ? /Android/i.test(navigator.userAgent) : !1;
    }
  }
};
var ue = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "app-badges" }, t._l(t.badgesByOs, function(s) {
    return e("a", { key: s.id, attrs: { href: s.href, target: "_blank" } }, [e("img", { attrs: { src: s.src, alt: s.altText, height: "40", loading: "lazy" } })]);
  }), 0);
}, le = [], he = /* @__PURE__ */ k(
  ce,
  ue,
  le,
  !1,
  null,
  "0242d5a0",
  null,
  null
);
const de = he.exports;
const pe = {
  name: "FooterInfoSection",
  mixins: [W],
  props: {
    baseUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      blogs: [
        {
          name: "네이버 블로그",
          url: "https://blog.naver.com/upgrade_me_30min",
          img: "illust-comento-naver-blog.png"
        },
        {
          name: "인스타그램",
          url: "https://www.instagram.com/comento.kr/?hl=ko",
          img: "illust-comento-instagram.png"
        },
        {
          name: "브런치",
          url: "https://brunch.co.kr/@comento",
          img: "illust-comento-brunch.png"
        }
      ]
    };
  },
  methods: {
    getBlogSrc(r) {
      return `https://cdn.comento.kr/images/illust/${r}`;
    }
  },
  components: {
    CustomNuxtLink: q,
    FooterAppDownloadBadges: de
  }
};
var me = function() {
  var t = this, e = t._self._c;
  return e("section", { staticClass: "footer-info", class: { mobile: t.isMobileView } }, [e("FooterAppDownloadBadges"), e("c-typography", { attrs: { type: "caption1", color: "gray400" } }, [t.isMobileView ? [t._v(" (주)코멘토ㅣ대표이사 이재성ㅣ사업자등록번호 487-86-00195"), e("br"), t._v(" 04512 서울특별시 중구 칠패로 28, 메리츠강북타워 3층"), e("br"), t._v(" 통신판매업신고번호 제 2018-서울중구-1245호ㅣ직업정보제공사업신고 "), e("br"), t._v(" 서울청 제 2018-19호ㅣ원격평생교육시설신고 제 원격-376호"), e("br"), t._v(" 유료직업소개사업 등록번호 제 2022-3010165-14-5-00021호"), e("br"), t._v(" 070-4154-0804 ")] : [t._v(" (주)코멘토ㅣ대표이사 이재성"), e("br"), t._v(" 04512 서울특별시 중구 칠패로 28, 메리츠강북타워 3층"), e("br"), t._v(" 사업자등록번호 487-86-00195ㅣ통신판매업신고번호 제 2018-서울중구-1245호"), e("br"), t._v(" 직업정보제공사업신고 서울청 제 2018-19호ㅣ원격평생교육시설신고 제 원격-376호"), e("br"), t._v(" 유료직업소개사업 등록번호 제 2022-3010165-14-5-00021호ㅣ070-4154-0804"), e("br")]], 2), e("div", { staticClass: "footer-info-sub-menus", class: { "mt-32": t.isMobileView } }, [e("div", [e("div", { staticClass: "flex align-center" }, [e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/agreement", "base-url": t.baseUrl } }, [e("c-typography", { attrs: { type: "caption1", color: "gray600" } }, [t._v(" 이용약관")])], 1), e("c-divider", { staticClass: "mx-8", staticStyle: { height: "12px" }, attrs: { vertical: "" } }), e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/agreement", "base-url": t.baseUrl } }, [e("c-typography", { attrs: { type: "caption1", color: "gray600", "font-weight": 600 } }, [t._v(" 개인정보처리방침 ")])], 1)], 1), e("c-typography", { staticClass: "mt-8", attrs: { type: "caption1", color: "gray400" } }, [t._v(" Copyright by (주)코멘토. All right reserved. ")])], 1), e("div", [e("ul", { staticClass: "footer-info-link-right" }, t._l(t.blogs, function({ img: s, name: i, url: d }, h) {
    return e("li", { key: `blog-${h}` }, [e("CustomNuxtLink", { attrs: { nuxt: !1, to: d, target: "_blank", external: "" } }, [e("img", { staticStyle: { width: "28px", height: "28px" }, attrs: { src: t.getBlogSrc(s), alt: `코멘토 ${i}`, loading: "lazy" } })])], 1);
  }), 0)])])], 1);
}, fe = [], _e = /* @__PURE__ */ k(
  pe,
  me,
  fe,
  !1,
  null,
  "8b0edfcf",
  null,
  null
);
const ye = _e.exports;
const ve = {
  name: "FooterCore",
  mixins: [W],
  computed: b({}, J(["domain"])),
  components: { FooterInfoSection: ye, FooterProductSection: ie, FooterServiceSection: re }
};
var ge = function() {
  var t = this, e = t._self._c;
  return e("footer", { staticClass: "footer", attrs: { id: "footer" } }, [e("c-new-grid", [e("c-new-row", [e("c-new-col", { attrs: { "col-sm": 4, "col-lg": 12 } }, [e("div", { staticClass: "flex", class: { "flex-column": t.isMobileView } }, [e("FooterServiceSection", { attrs: { "base-url": t.domain } }), e("c-divider", { staticClass: "mx-32", attrs: { vertical: "" } }), e("FooterProductSection", { attrs: { "base-url": t.domain } }), e("c-divider", { staticClass: "mx-32", attrs: { vertical: "" } }), e("FooterInfoSection", { attrs: { "base-url": t.domain } })], 1)])], 1)], 1)], 1);
}, we = [], be = /* @__PURE__ */ k(
  ve,
  ge,
  we,
  !1,
  null,
  "bfad178c",
  null,
  null
);
const Se = be.exports, $e = {
  name: "ComentoFooter",
  props: {
    isSlim: {
      type: Boolean,
      default: !1
    }
  },
  components: { SlimFooter: Jt, FooterCore: Se }
};
var Ce = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "footer-wrapper" }, [t.isSlim ? e("SlimFooter") : e("FooterCore")], 1);
}, xe = [], ke = /* @__PURE__ */ k(
  $e,
  Ce,
  xe,
  !1,
  null,
  null,
  null,
  null
);
const ls = ke.exports;
const Me = {
  name: "AutocompleteItem",
  props: {
    searchKeyword: {
      type: String,
      default: ""
    },
    keyword: {
      type: String,
      default: ""
    }
  },
  methods: I(b({}, X(["search"])), {
    getAutocompleteColor(r) {
      if (r) {
        if (!this.searchKeyword)
          return r;
        const e = this.searchKeyword.split(" ").join("|").replace(/[.*+?^${}()|[\]\\]/g, "\\$&"), s = new RegExp(e, "gi");
        return r.replace(s, (i) => `<span style="color: #2A7DE1">${i}</span>`);
      }
    },
    clickAutocomplete() {
      const r = {
        searchType: "autocomplete",
        keyword: this.keyword
      };
      this.search(r), this.$emit("click-autocomplete", r);
    }
  })
};
var Ae = function() {
  var t = this, e = t._self._c;
  return e("c-list-item", { staticClass: "search-autocomplete-item", on: { click: t.clickAutocomplete } }, [e("c-icon", { staticClass: "mr-8", attrs: { name: "IconSearchSmallLine", color: "gray500" } }), e("c-typography", { attrs: { type: "body2", "font-weight": 400, color: "gray800" }, domProps: { innerHTML: t._s(t.getAutocompleteColor(t.keyword)) } })], 1);
}, De = [], Le = /* @__PURE__ */ k(
  Me,
  Ae,
  De,
  !1,
  null,
  "b90fa3a3",
  null,
  null
);
const Ie = Le.exports;
const Be = {
  name: "AutocompleteList",
  props: {
    keyword: {
      type: String,
      default: null
    }
  },
  computed: I(b({}, J(["keywords"])), {
    searchKeyword() {
      return this.keyword === null ? this.keywords.search : this.keyword;
    }
  }),
  methods: {
    clickKeyword({ searchType: r, keyword: t }) {
      this.$emit("click-autocomplete", { searchType: r, keyword: t });
    }
  },
  components: { AutocompleteItem: Ie }
};
var Ne = function() {
  var t = this, e = t._self._c;
  return e("c-list", { staticClass: "search-autocomplete" }, t._l(t.keywords.autocomplete, function(s, i) {
    return e("AutocompleteItem", { key: `search-autocomplete-${i}`, attrs: { "search-keyword": t.searchKeyword, keyword: s }, on: { "click-autocomplete": t.clickKeyword } });
  }), 1);
}, He = [], Ee = /* @__PURE__ */ k(
  Be,
  Ne,
  He,
  !1,
  null,
  "781813ea",
  null,
  null
);
const gt = Ee.exports;
const Oe = {
  name: "RecentSearchItem",
  props: {
    keyword: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: {
    // clipKeyword() {
    // 	if (this.keyword.length > 16) {
    // 		const str = this.keyword;
    // 		return `${str.substring(0, 16)}...`;
    // 	}
    // 	return this.keyword;
    // },
  },
  methods: I(b({}, X(["clickRecentKeyword", "removeRecentKeyword", "search"])), {
    removeKeyword() {
      this.removeRecentKeyword({ keyword: this.keyword, index: this.index });
    },
    clickKeyword() {
      this.$store.commit("_commonComponents/setKeywords", I(b({}, this.keywords), {
        search: this.keyword
      }));
      const r = { keyword: this.keyword, searchType: "recent" };
      this.search(r), this.$emit("click-keyword", r);
    }
  })
};
var Re = function() {
  var t = this, e = t._self._c;
  return e("c-list-item", { staticClass: "recent-search-item", on: { click: t.clickKeyword } }, [e("div", { staticClass: "recent-search-item-content" }, [e("c-icon", { staticClass: "mr-8", attrs: { name: "IconClockSmallLine", color: "gray500" } }), e("c-typography", { attrs: { type: "body2", "font-weight": 400, color: "gray800" } }, [t._v(" " + t._s(t.keyword) + " ")])], 1), e("div", { staticClass: "recent-search-item-remove", on: { click: function(s) {
    return s.stopPropagation(), t.removeKeyword.apply(null, arguments);
  } } }, [e("c-icon-button", { attrs: { size: "small", "icon-name": "IconCloseSmallLine", color: "gray300" } })], 1)]);
}, Te = [], Pe = /* @__PURE__ */ k(
  Oe,
  Re,
  Te,
  !1,
  null,
  "5fba24f9",
  null,
  null
);
const wt = Pe.exports;
const Ue = {
  name: "DropdownList",
  computed: I(b({}, J(["keywords"])), {
    showRecentKeyword() {
      var r;
      return !!this.keywords.recent && ((r = this.keywords.recent) == null ? void 0 : r.length);
    }
  }),
  components: {
    RecentSearchItem: wt
  }
};
var Ke = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "dropdown-container" }, [t.showRecentKeyword ? e("div", { staticClass: "dropdown-recent-wrapper" }, [e("div", { staticClass: "dropdown-recent" }, [e("c-typography", { staticClass: "mb-12", attrs: { type: "caption1", "font-weight": 400, color: "gray400" } }, [t._v(" 최근 검색어 ")]), e("c-list", { staticClass: "dropdown-recent-list" }, t._l(t.keywords.recent, function(s, i) {
    return e("RecentSearchItem", { key: `recent-search-list-${i}`, attrs: { keyword: s, index: i } });
  }), 1)], 1)]) : t._e()]);
}, Fe = [], Ve = /* @__PURE__ */ k(
  Ue,
  Ke,
  Fe,
  !1,
  null,
  "c1dfc8ee",
  null,
  null
);
const We = Ve.exports, st = {
  mixins: [W],
  computed: {
    route() {
      const r = !!this.$route, t = b({}, this.$route);
      return r && !t.name && (t.name = t.path.split("/").filter((e) => e).join("-")), r ? t : {
        fullPath: "/job-wiki",
        // fullPath: '/mypage',
        // fullPath: '/product/externship',
        // fullPath: '/edu/learn/asd/asd-G2313',
        // fullPath: '/kdigital/연구개발/어려운-회로-공식-그만-눈으로-하는-반도체-회로-CHIP-설계',
        // fullPath: '/search/pt/마케팅?sort=relevance&origin=pt',
        // fullPath: '/search/community/현대자동차',
        hash: "",
        matched: [],
        meta: {},
        name: "job-wiki",
        // name: 'mypage',
        // name: 'externship',
        // name: 'edu-learn-top-camp',
        // name: 'edu-list',
        // name: 'product-class',
        // name: 'search-product-keyword',
        // name: 'class-pt',
        // name: 'kdigital-top-title',
        params: {
          // product: 'pt',
        },
        path: "/job-wiki",
        // path: '/mypage',
        // path: '/kdigital/연구개발/어려운-회로-공식-그만-눈으로-하는-반도체-회로-CHIP-설계',
        // path: '/edu/learn/asd/asd-G2313',
        // path: '/class/pt',
        // path: '/class/pt/apply/1234',
        // path: '/search/pt/마케팅',
        query: {
          // 	// source: 'pt',
          jobs: "디자인|건축디자인"
        }
      };
    },
    router() {
      return this.isNuxt ? this.$router : {
        push: (r) => location.href = r,
        back: () => history.back(),
        replace: (r) => location.replace = r
      };
    },
    isSearch() {
      const { name: r } = this.route;
      return r === Y.SEARCH_LIST;
    },
    isCommunityMenu() {
      const { name: r } = this.route;
      return [
        "job-questions-keyword",
        "answer",
        "community-lounge",
        "community-insight"
        // 'job-wiki',
      ].includes(r);
    },
    isCommunityTimeline() {
      return this.route.name === "job-questions-keyword" && !this.route.query.feed;
    },
    isCommunityWorkSkill() {
      return this.isCommunity && this.route.query.category === "실무스킬";
    },
    isCommunityJobChanging() {
      return this.isCommunity && this.route.query.category === "이직 고민";
    },
    isCommunityWorker() {
      return this.isCommunity && this.route.query.category === "랜선 사수";
    },
    isCommunityJobSeeking() {
      return this.isCommunity && this.route.query.category === "취업 고민";
    },
    isCommunityCollege() {
      return this.isCommunity && this.route.query.category === "대학생 고민";
    },
    isCommunityQna() {
      return this.isCommunity && this.route.query.feed === "recent";
    },
    isJobWiki() {
      return this.route.name === "job-wiki";
    },
    isAnswer() {
      return this.route.name === "answer";
    },
    isClassMenu() {
      return this.isClassHome || this.isEduMenu || this.isPt || this.isPathMenu || this.isVodMenu || this.isTrainingMenu || this.isKDigitalMenu;
    },
    isClassHome() {
      return this.route.name === "class";
    },
    isEduMenu() {
      return this.route.name.startsWith("edu") && !this.isPathMenu && !this.isApplyAndPaymentPage;
    },
    isEduList() {
      return this.route.name === "edu-list";
    },
    isEduDetail() {
      return this.route.name === "edu-learn-top-camp";
    },
    isPt() {
      return this.route.path.startsWith("/class/pt") || this.isPtProductClassPage || this.isPtProductGenAICLassPage || this.isPtSearch;
    },
    isPtIndex() {
      return this.route.name === "class-pt";
    },
    isPtList() {
      return this.route.name === "class-pt-list-keyword";
    },
    isPtDetail() {
      return this.route.name === "class-pt-content-title-classNo";
    },
    isPtProductClassPage() {
      return this.route.name === "product-class";
    },
    isPtProductGenAICLassPage() {
      return this.route.name === "product-b2b-gen-ai-class";
    },
    isPtSearch() {
      const { name: r, params: t, query: e } = this.route;
      return r === "search-product-keyword" && t.product === "pt" && e.origin === "pt";
    },
    isPathMenu() {
      return this.route.path.startsWith("/edu/path");
    },
    isVodMenu() {
      const r = this.route.path;
      return r.startsWith("/vod") || r.startsWith("/class/vod");
    },
    isVodDetail() {
      return this.route.name === "vod-lecture-top-title";
    },
    isClassVodDetail() {
      return ["class-vod-detail-no", "class-vod-detail-sample-no"].includes(this.route.name);
    },
    isCommunity() {
      const r = this.route.name;
      return ["job-questions-keyword", "job-wiki", "answer"].includes(r);
    },
    isRecruitMenu() {
      return this.route.path.startsWith("/career/recruit");
    },
    isDreamverseMenu() {
      return this.route.path.startsWith("/career/dreamverse");
    },
    isExternshipMenu() {
      return this.route.path.startsWith("/career/externship");
    },
    isCareerMenu() {
      return this.route.path.startsWith("/career");
    },
    isMyPage() {
      return this.route.path.includes("/mypage");
    },
    isTopMenu() {
      return this.isCommunity || this.isClassHome || this.isExternshipMenu;
    },
    isPageWithFilter() {
      return this.isEduList;
    },
    isApplyAndPaymentPage() {
      const r = this.route.name;
      return r.includes("apply") || r.includes("pay");
    },
    isTrainingMenu() {
      const r = "/class/sesac/";
      return this.route.path.startsWith("/class/training") || this.route.path.startsWith(r);
    },
    isKDigitalMenu() {
      return this.route.path.startsWith("/kdigital");
    }
  }
};
const je = {
  name: "UserMenu",
  mixins: [W],
  props: {
    isShowUserMenuDropdown: {
      type: Boolean,
      default: !1
    },
    userInfo: {
      type: Object,
      default: () => ({})
    },
    hasProfileImage: {
      type: Boolean,
      default: !1
    }
  },
  methods: I(b({}, X(["logout"])), {
    onClickLogout() {
      this.logout();
    }
  }),
  components: { CustomNuxtLink: q }
};
var Ye = function() {
  var s, i, d, h;
  var t = this, e = t._self._c;
  return e("div", t._g(t._b({ staticClass: "user-menu-container" }, "div", t.$attrs, !1), t.$listeners), [e("c-list", { staticClass: "user-menu-list" }, [e("CustomNuxtLink", { staticClass: "c-pointer", attrs: { nuxt: t.isNuxt, to: "/mypage" } }, [e("div", { staticClass: "user-menu-top" }, [e("c-avatar", { attrs: { type: t.hasProfileImage ? "image" : "profile", size: "small", src: (i = (s = t.userInfo) == null ? void 0 : s.profileImage) != null ? i : "" } }), e("div", { staticClass: "user-menu-top-info" }, [e("c-typography", { staticClass: "user-menu-top-info-nickname", attrs: { type: "caption1", "font-weight": 600, color: "gray800" } }, [t._v(" " + t._s((h = (d = t.userInfo) == null ? void 0 : d.name) != null ? h : "") + " ")]), e("c-typography", { attrs: { type: "caption2", "font-weight": 400, color: "gray400" } }, [t._v(" 내 프로필 보기 ")])], 1)], 1)]), t.$slots.banner ? e("div", { staticClass: "user-menu-banner" }, [t._t("banner")], 2) : t._e(), e("c-divider", { staticClass: "user-menu-top-divider my-6", attrs: { color: "gray100" } }), e("CustomNuxtLink", { attrs: { nuxt: !0, to: "/mypage/community" } }, [e("c-list-item", { staticClass: "user-menu-list-item" }, [e("c-typography", { attrs: { type: "body2", "font-weight": 400, color: "gray800" } }, [t._v(" 커뮤니티 활동 ")])], 1)], 1), e("CustomNuxtLink", { attrs: { nuxt: !0, to: "/mypage/classroom" } }, [e("c-list-item", { staticClass: "user-menu-list-item" }, [e("c-typography", { attrs: { type: "body2", "font-weight": 400, color: "gray800" } }, [t._v(" 내 클래스룸 ")])], 1)], 1), e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/coupon/book" } }, [e("c-list-item", { staticClass: "user-menu-list-item" }, [e("c-typography", { attrs: { type: "body2", "font-weight": 400, color: "gray800" } }, [t._v(" 쿠폰북 ")])], 1)], 1), e("CustomNuxtLink", { attrs: { nuxt: !1, to: "/mentor" } }, [e("c-list-item", { staticClass: "user-menu-list-item" }, [e("c-typography", { attrs: { type: "body2", "font-weight": 400, color: "gray800" } }, [t._v(" 멘토 등록하기 ")]), e("c-icon", { attrs: { name: "IconArrowSmallLine", rotate: 90 } })], 1)], 1), e("c-divider", { staticClass: "my-6", attrs: { color: "gray100" } }), e("c-list-item", { staticClass: "user-menu-list-item", on: { click: t.onClickLogout } }, [e("c-typography", { attrs: { type: "body2", "font-weight": 400, color: "gray500" } }, [t._v(" 로그아웃 ")])], 1)], 1)], 1);
}, ze = [], qe = /* @__PURE__ */ k(
  je,
  Ye,
  ze,
  !1,
  null,
  "9ce66285",
  null,
  null
);
const Je = qe.exports;
const Qe = {
  name: "TopBarActionButton",
  computed: b({}, J(["header"]))
};
var Ge = function() {
  var t = this, e = t._self._c;
  return e("li", { staticClass: "top-bar-action-button", class: { transparent: t.header.transparent } }, [t._t("default")], 2);
}, Ze = [], Xe = /* @__PURE__ */ k(
  Qe,
  Ge,
  Ze,
  !1,
  null,
  "e2e744dd",
  null,
  null
);
const it = Xe.exports;
const tr = {
  name: "SearchActionButton",
  mixins: [W],
  methods: I(b({}, X(["openSearch"])), {
    onClickButton() {
      this.openSearch();
    }
  }),
  components: {
    TopBarActionButton: it
  }
};
var er = function() {
  var t = this, e = t._self._c;
  return e("TopBarActionButton", { nativeOn: { click: function(s) {
    return t.onClickButton.apply(null, arguments);
  } } }, [e("c-icon-button", { attrs: { "icon-name": "IconSearchLargeLine", size: "medium", color: "gray400", "aria-label": "검색" } })], 1);
}, rr = [], sr = /* @__PURE__ */ k(
  tr,
  er,
  rr,
  !1,
  null,
  "842606c4",
  null,
  null
);
const or = sr.exports;
const nr = {
  name: "BookmarkActionButton",
  mixins: [st],
  props: {
    bookmarkCount: {
      type: Number,
      default: 0
    }
  },
  computed: b({}, J(["header"])),
  methods: {
    onClickButton() {
      const r = "/bookmark";
      let t = r;
      this.isPt ? t = r + "?tab=class&filter=" + Wt : this.isClassMenu && (t = r + "?tab=class"), this.router.push(t);
    }
  },
  components: {
    TopBarActionButton: it
  }
};
var ar = function() {
  var t = this, e = t._self._c;
  return e("TopBarActionButton", { nativeOn: { click: function(s) {
    return t.onClickButton.apply(null, arguments);
  } } }, [e("c-badge", { attrs: { size: "small", text: t.bookmarkCount, "offset-x": 12, "offset-y": 28 } }, [e("c-icon-button", { attrs: { "icon-name": "IconBookmarkLargeLine", color: "gray400", "aria-label": "북마크" } })], 1)], 1);
}, ir = [], cr = /* @__PURE__ */ k(
  nr,
  ar,
  ir,
  !1,
  null,
  "75ee6894",
  null,
  null
);
const ur = cr.exports;
const lr = {
  name: "NotificationActionButton",
  props: {
    notificationCount: {
      type: Number,
      default: 0
    }
  },
  methods: I(b({}, X(["clickNoti"])), {
    onClickButton() {
      this.clickNoti();
    }
  }),
  components: {
    TopBarActionButton: it
  }
};
var hr = function() {
  var t = this, e = t._self._c;
  return e("TopBarActionButton", { nativeOn: { click: function(s) {
    return t.onClickButton.apply(null, arguments);
  } } }, [e("c-badge", { attrs: { size: "small", text: t.notificationCount, "offset-x": 12, "offset-y": 28, color: "secondary" } }, [e("c-icon-button", { attrs: { "icon-name": "IconAlarmLargeLine", color: "gray400", "aria-label": "알림 보기" } })], 1)], 1);
}, dr = [], pr = /* @__PURE__ */ k(
  lr,
  hr,
  dr,
  !1,
  null,
  "33f637fc",
  null,
  null
);
const mr = pr.exports;
const fr = {
  name: "HeaderLinkButton",
  props: {
    label: {
      type: String,
      required: !0
    },
    to: {
      type: String,
      required: !0
    },
    external: {
      type: Boolean,
      default: !1
    },
    nuxt: {
      type: Boolean,
      default: !1
    },
    transparent: {
      type: Boolean,
      default: !1
    },
    baseUrl: {
      type: String,
      default: ""
    }
  },
  components: {
    CustomNuxtLink: q
  }
};
var _r = function() {
  var t = this, e = t._self._c;
  return e("li", { staticClass: "header-info-section-item", class: { transparent: t.transparent } }, [e("CustomNuxtLink", { attrs: { nuxt: t.nuxt, external: t.external, to: t.to, "base-url": t.baseUrl } }, [e("c-narrow-button", { attrs: { size: "medium", color: "gray500", "aria-label": t.label } }, [t._v(" " + t._s(t.label) + " ")])], 1)], 1);
}, yr = [], vr = /* @__PURE__ */ k(
  fr,
  _r,
  yr,
  !1,
  null,
  "7f130859",
  null,
  null
);
const gr = vr.exports;
const wr = {
  name: "HeaderInfoSection",
  mixins: [st, W],
  data() {
    return {
      showuserDropdown: !1
    };
  },
  computed: I(b({}, J(["user", "domain", "count", "topBar", "header"])), {
    isValidUser() {
      return !!this.user.id;
    },
    hasProfileImage() {
      var r;
      return !!((r = this.user) != null && r.profileImage);
    },
    userProfileSrc() {
      return this.hasProfileImage ? this.user.profileImage : "";
    },
    actionButtons() {
      const { SEARCH: r, BOOKMARK: t, NOTIFICATION: e } = yt, s = {
        [r]: "SearchActionButton",
        [t]: "BookmarkActionButton",
        [e]: "NotificationActionButton"
      };
      return this.topBar.actions.map((i) => s[i]);
    },
    loginUrl() {
      return "/login?redirect_url=" + this.$route.path;
    },
    computedHeaderLinks() {
      return [
        {
          label: "가입/로그인",
          to: this.loginUrl,
          baseUrl: this.domain
        },
        ...Vt
      ];
    }
  }),
  methods: {
    onMouseEnterInfo() {
      this.showuserDropdown = !0;
    },
    onMouseOutInfo() {
      this.showuserDropdown = !1;
    },
    actionButtonProps(r) {
      return r === "SearchActionButton" ? {} : r === "BookmarkActionButton" ? {
        props: {
          bookmarkCount: this.count.bookmark
        }
      } : r === "NotificationActionButton" ? {
        props: {
          notificationCount: this.count.notification
        }
      } : {};
    }
  },
  components: {
    UserMenu: Je,
    SearchActionButton: or,
    BookmarkActionButton: ur,
    NotificationActionButton: mr,
    CustomNuxtLink: q,
    HeaderLinkButton: gr
  }
};
var br = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "flex align-center" }, [e("ul", { staticClass: "flex ml-16 header-info-section-list" }, [t.isMobileView ? [t._t("top-bar"), t._l(t.actionButtons, function(s) {
    return e(s, t._g(t._b({ key: s, tag: "component" }, "component", t.actionButtonProps(s).props, !1), t.actionButtonProps(s).methods));
  })] : [t.isValidUser ? [e("BookmarkActionButton", { attrs: { "bookmark-count": t.count.bookmark } }), e("NotificationActionButton", { attrs: { "notification-count": t.count.notification } }), e("li", { staticClass: "header-info-section-item ml-4" }, [e("c-popover", { attrs: { placement: "bottom" }, scopedSlots: t._u([{ key: "popover", fn: function() {
    return [e("UserMenu", { attrs: { "is-show-user-menu-dropdown": t.showuserDropdown, "user-info": t.user, "has-profile-image": t.hasProfileImage }, scopedSlots: t._u([{ key: "banner", fn: function() {
      return [t._t("banner")];
    }, proxy: !0 }], null, !0) })];
  }, proxy: !0 }], null, !1, 3681785240) }, [e("CustomNuxtLink", { staticClass: "user-avatar c-pointer", attrs: { nuxt: "", to: "/mypage/classroom" } }, [e("c-avatar", { attrs: { type: t.hasProfileImage ? "image" : "profile", size: "xsmall", src: t.userProfileSrc } })], 1)], 1)], 1)] : [e("div", { staticClass: "header-info-section-link-container" }, t._l(t.computedHeaderLinks, function(s) {
    return e("HeaderLinkButton", { key: s.label, attrs: { label: s.label, to: s.to, "base-url": s.baseUrl, nuxt: s.nuxt, transparent: t.header.transparent } });
  }), 1)]]], 2)]);
}, Sr = [], $r = /* @__PURE__ */ k(
  wr,
  br,
  Sr,
  !1,
  null,
  "90f501f6",
  null,
  null
);
const bt = $r.exports;
const Cr = {
  name: "HeaderCore",
  mixins: [W],
  props: {
    activatedMenu: {
      type: Number,
      default: -1
    },
    hoveredMenu: {
      type: Number,
      default: -1
    },
    searchPlaceholder: {
      type: String,
      default: ""
    },
    showDropdown: {
      type: Boolean,
      default: !1
    },
    items: {
      type: Array,
      default: () => []
    },
    logoUrl: {
      type: String,
      default: "https://comento.kr"
    }
  },
  computed: I(b({}, J(["isWithAlert", "keywords", "header"])), {
    sync_showDropdown: {
      get() {
        return this.showDropdown;
      },
      set(r) {
        return this.$emit("update:showDropdown", r);
      }
    },
    sync_searchKeyword: {
      get() {
        return this.keywords.search;
      },
      set(r) {
        const t = decodeURIComponent(r);
        this.$store.commit("_commonComponents/setKeywords", I(b({}, this.keywords), {
          search: t
        }));
      }
    },
    showDefaultDropdownList() {
      return this.sync_showDropdown && !this.sync_searchKeyword && this.keywords.recent.length > 0;
    },
    showAutocompleteList() {
      return this.sync_showDropdown && this.sync_searchKeyword && this.keywords.autocomplete.length > 0;
    },
    showDropdownList() {
      return this.showDefaultDropdownList || this.showAutocompleteList;
    }
  }),
  methods: {
    onMouseEntered(r) {
      this.$emit("update-nav", r);
    },
    doSearch({ keyword: r, searchType: t }) {
      this.$emit("search", { keyword: r, searchType: t });
    },
    updateMouseEnterHeader() {
      this.$emit("mouse-enter-header");
    }
  },
  components: { DropdownList: We, AutocompleteList: gt, HeaderInfoSection: bt }
};
var xr = function() {
  var t = this, e = t._self._c;
  return e("header", { staticClass: "header", class: { transparent: t.header.transparent, "with-alert": t.isWithAlert } }, [e("c-new-grid", [e("c-new-row", [e("c-new-col", { attrs: { "col-lg": 12 } }, [e("nav", { staticClass: "header-nav" }, [e("div", [e("c-header", { attrs: { "activated-menu": t.activatedMenu, "hovered-menu": t.hoveredMenu, items: t.items, "is-transparent": t.header.transparent, "logo-url": t.logoUrl }, on: { "update-nav": t.onMouseEntered } })], 1), e("aside", { staticClass: "ml-auto flex align-center" }, [e("c-dropdown", { staticClass: "search-dropdown", class: { "dropdown-disappear": !t.showDropdownList }, attrs: { "max-width": "300px", "max-height": "255px", "show-dropdown": t.sync_showDropdown }, on: { "update:showDropdown": function(s) {
    t.sync_showDropdown = s;
  }, "update:show-dropdown": function(s) {
    t.sync_showDropdown = s;
  } }, scopedSlots: t._u([{ key: "item", fn: function() {
    return [e("div", { staticClass: "p-relative" }, [e("c-search-input", { ref: "searchInput", staticClass: "search", attrs: { full: "", value: t.sync_searchKeyword, placeholder: t.searchPlaceholder, "show-search-dropdown": t.sync_showDropdown, transparent: t.header.transparent, "data-cy": "searchInput" }, on: { "update:value": function(s) {
      t.sync_searchKeyword = s;
    }, "update:showSearchDropdown": function(s) {
      t.sync_showDropdown = s;
    }, "update:show-search-dropdown": function(s) {
      t.sync_showDropdown = s;
    }, search: function(s) {
      return t.doSearch({ keyword: t.sync_searchKeyword, searchType: "typing" });
    } } })], 1)];
  }, proxy: !0 }, { key: "list", fn: function() {
    return [e("DropdownList", { directives: [{ name: "show", rawName: "v-show", value: t.showDefaultDropdownList, expression: "showDefaultDropdownList" }], staticClass: "mb-8", scopedSlots: t._u([{ key: "before-popular-list", fn: function() {
      return [t._t("before-popular-list")];
    }, proxy: !0 }], null, !0) }), e("AutocompleteList", { directives: [{ name: "show", rawName: "v-show", value: t.showAutocompleteList, expression: "showAutocompleteList" }], staticClass: "mt-8", attrs: { "search-keyword": t.sync_searchKeyword } })];
  }, proxy: !0 }]) }), t.isNuxt ? e("client-only", [e("HeaderInfoSection", { scopedSlots: t._u([{ key: "banner", fn: function() {
    return [t._t("banner")];
  }, proxy: !0 }], null, !0) })], 1) : e("HeaderInfoSection", { scopedSlots: t._u([{ key: "banner", fn: function() {
    return [t._t("banner")];
  }, proxy: !0 }], null, !0) })], 1)])])], 1)], 1), e("c-divider", { style: { opacity: t.header.transparent ? 0.1 : 1 }, attrs: { color: "gray100" } })], 1);
}, kr = [], Mr = /* @__PURE__ */ k(
  Cr,
  xr,
  kr,
  !1,
  null,
  "74b705de",
  null,
  null
);
const Ar = Mr.exports;
var ct = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function ut(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var St = { exports: {} };
(function(r, t) {
  (function(e, s) {
    r.exports = s();
  })(ct, function() {
    var e = 1e3, s = 6e4, i = 36e5, d = "millisecond", h = "second", y = "minute", u = "hour", v = "day", N = "week", A = "month", _ = "quarter", $ = "year", w = "date", c = "Invalid Date", S = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, O = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, D = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(p) {
      var a = ["th", "st", "nd", "rd"], o = p % 100;
      return "[" + p + (a[(o - 20) % 10] || a[o] || a[0]) + "]";
    } }, L = function(p, a, o) {
      var l = String(p);
      return !l || l.length >= a ? p : "" + Array(a + 1 - l.length).join(o) + p;
    }, F = { s: L, z: function(p) {
      var a = -p.utcOffset(), o = Math.abs(a), l = Math.floor(o / 60), n = o % 60;
      return (a <= 0 ? "+" : "-") + L(l, 2, "0") + ":" + L(n, 2, "0");
    }, m: function p(a, o) {
      if (a.date() < o.date())
        return -p(o, a);
      var l = 12 * (o.year() - a.year()) + (o.month() - a.month()), n = a.clone().add(l, A), m = o - n < 0, f = a.clone().add(l + (m ? -1 : 1), A);
      return +(-(l + (o - n) / (m ? n - f : f - n)) || 0);
    }, a: function(p) {
      return p < 0 ? Math.ceil(p) || 0 : Math.floor(p);
    }, p: function(p) {
      return { M: A, y: $, w: N, d: v, D: w, h: u, m: y, s: h, ms: d, Q: _ }[p] || String(p || "").toLowerCase().replace(/s$/, "");
    }, u: function(p) {
      return p === void 0;
    } }, H = "en", T = {};
    T[H] = D;
    var U = "$isDayjsObject", j = function(p) {
      return p instanceof nt || !(!p || !p[U]);
    }, K = function p(a, o, l) {
      var n;
      if (!a)
        return H;
      if (typeof a == "string") {
        var m = a.toLowerCase();
        T[m] && (n = m), o && (T[m] = o, n = m);
        var f = a.split("-");
        if (!n && f.length > 1)
          return p(f[0]);
      } else {
        var C = a.name;
        T[C] = a, n = C;
      }
      return !l && n && (H = n), n || !l && H;
    }, x = function(p, a) {
      if (j(p))
        return p.clone();
      var o = typeof a == "object" ? a : {};
      return o.date = p, o.args = arguments, new nt(o);
    }, g = F;
    g.l = K, g.i = j, g.w = function(p, a) {
      return x(p, { locale: a.$L, utc: a.$u, x: a.$x, $offset: a.$offset });
    };
    var nt = function() {
      function p(o) {
        this.$L = K(o.locale, null, !0), this.parse(o), this.$x = this.$x || o.x || {}, this[U] = !0;
      }
      var a = p.prototype;
      return a.parse = function(o) {
        this.$d = function(l) {
          var n = l.date, m = l.utc;
          if (n === null)
            return /* @__PURE__ */ new Date(NaN);
          if (g.u(n))
            return /* @__PURE__ */ new Date();
          if (n instanceof Date)
            return new Date(n);
          if (typeof n == "string" && !/Z$/i.test(n)) {
            var f = n.match(S);
            if (f) {
              var C = f[2] - 1 || 0, B = (f[7] || "0").substring(0, 3);
              return m ? new Date(Date.UTC(f[1], C, f[3] || 1, f[4] || 0, f[5] || 0, f[6] || 0, B)) : new Date(f[1], C, f[3] || 1, f[4] || 0, f[5] || 0, f[6] || 0, B);
            }
          }
          return new Date(n);
        }(o), this.init();
      }, a.init = function() {
        var o = this.$d;
        this.$y = o.getFullYear(), this.$M = o.getMonth(), this.$D = o.getDate(), this.$W = o.getDay(), this.$H = o.getHours(), this.$m = o.getMinutes(), this.$s = o.getSeconds(), this.$ms = o.getMilliseconds();
      }, a.$utils = function() {
        return g;
      }, a.isValid = function() {
        return this.$d.toString() !== c;
      }, a.isSame = function(o, l) {
        var n = x(o);
        return this.startOf(l) <= n && n <= this.endOf(l);
      }, a.isAfter = function(o, l) {
        return x(o) < this.startOf(l);
      }, a.isBefore = function(o, l) {
        return this.endOf(l) < x(o);
      }, a.$g = function(o, l, n) {
        return g.u(o) ? this[l] : this.set(n, o);
      }, a.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, a.valueOf = function() {
        return this.$d.getTime();
      }, a.startOf = function(o, l) {
        var n = this, m = !!g.u(l) || l, f = g.p(o), C = function(G, P) {
          var z = g.w(n.$u ? Date.UTC(n.$y, P, G) : new Date(n.$y, P, G), n);
          return m ? z : z.endOf(v);
        }, B = function(G, P) {
          return g.w(n.toDate()[G].apply(n.toDate("s"), (m ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(P)), n);
        }, E = this.$W, R = this.$M, V = this.$D, Z = "set" + (this.$u ? "UTC" : "");
        switch (f) {
          case $:
            return m ? C(1, 0) : C(31, 11);
          case A:
            return m ? C(1, R) : C(0, R + 1);
          case N:
            var Q = this.$locale().weekStart || 0, tt = (E < Q ? E + 7 : E) - Q;
            return C(m ? V - tt : V + (6 - tt), R);
          case v:
          case w:
            return B(Z + "Hours", 0);
          case u:
            return B(Z + "Minutes", 1);
          case y:
            return B(Z + "Seconds", 2);
          case h:
            return B(Z + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, a.endOf = function(o) {
        return this.startOf(o, !1);
      }, a.$set = function(o, l) {
        var n, m = g.p(o), f = "set" + (this.$u ? "UTC" : ""), C = (n = {}, n[v] = f + "Date", n[w] = f + "Date", n[A] = f + "Month", n[$] = f + "FullYear", n[u] = f + "Hours", n[y] = f + "Minutes", n[h] = f + "Seconds", n[d] = f + "Milliseconds", n)[m], B = m === v ? this.$D + (l - this.$W) : l;
        if (m === A || m === $) {
          var E = this.clone().set(w, 1);
          E.$d[C](B), E.init(), this.$d = E.set(w, Math.min(this.$D, E.daysInMonth())).$d;
        } else
          C && this.$d[C](B);
        return this.init(), this;
      }, a.set = function(o, l) {
        return this.clone().$set(o, l);
      }, a.get = function(o) {
        return this[g.p(o)]();
      }, a.add = function(o, l) {
        var n, m = this;
        o = Number(o);
        var f = g.p(l), C = function(R) {
          var V = x(m);
          return g.w(V.date(V.date() + Math.round(R * o)), m);
        };
        if (f === A)
          return this.set(A, this.$M + o);
        if (f === $)
          return this.set($, this.$y + o);
        if (f === v)
          return C(1);
        if (f === N)
          return C(7);
        var B = (n = {}, n[y] = s, n[u] = i, n[h] = e, n)[f] || 1, E = this.$d.getTime() + o * B;
        return g.w(E, this);
      }, a.subtract = function(o, l) {
        return this.add(-1 * o, l);
      }, a.format = function(o) {
        var l = this, n = this.$locale();
        if (!this.isValid())
          return n.invalidDate || c;
        var m = o || "YYYY-MM-DDTHH:mm:ssZ", f = g.z(this), C = this.$H, B = this.$m, E = this.$M, R = n.weekdays, V = n.months, Z = n.meridiem, Q = function(P, z, et, at) {
          return P && (P[z] || P(l, m)) || et[z].slice(0, at);
        }, tt = function(P) {
          return g.s(C % 12 || 12, P, "0");
        }, G = Z || function(P, z, et) {
          var at = P < 12 ? "AM" : "PM";
          return et ? at.toLowerCase() : at;
        };
        return m.replace(O, function(P, z) {
          return z || function(et) {
            switch (et) {
              case "YY":
                return String(l.$y).slice(-2);
              case "YYYY":
                return g.s(l.$y, 4, "0");
              case "M":
                return E + 1;
              case "MM":
                return g.s(E + 1, 2, "0");
              case "MMM":
                return Q(n.monthsShort, E, V, 3);
              case "MMMM":
                return Q(V, E);
              case "D":
                return l.$D;
              case "DD":
                return g.s(l.$D, 2, "0");
              case "d":
                return String(l.$W);
              case "dd":
                return Q(n.weekdaysMin, l.$W, R, 2);
              case "ddd":
                return Q(n.weekdaysShort, l.$W, R, 3);
              case "dddd":
                return R[l.$W];
              case "H":
                return String(C);
              case "HH":
                return g.s(C, 2, "0");
              case "h":
                return tt(1);
              case "hh":
                return tt(2);
              case "a":
                return G(C, B, !0);
              case "A":
                return G(C, B, !1);
              case "m":
                return String(B);
              case "mm":
                return g.s(B, 2, "0");
              case "s":
                return String(l.$s);
              case "ss":
                return g.s(l.$s, 2, "0");
              case "SSS":
                return g.s(l.$ms, 3, "0");
              case "Z":
                return f;
            }
            return null;
          }(P) || f.replace(":", "");
        });
      }, a.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, a.diff = function(o, l, n) {
        var m, f = this, C = g.p(l), B = x(o), E = (B.utcOffset() - this.utcOffset()) * s, R = this - B, V = function() {
          return g.m(f, B);
        };
        switch (C) {
          case $:
            m = V() / 12;
            break;
          case A:
            m = V();
            break;
          case _:
            m = V() / 3;
            break;
          case N:
            m = (R - E) / 6048e5;
            break;
          case v:
            m = (R - E) / 864e5;
            break;
          case u:
            m = R / i;
            break;
          case y:
            m = R / s;
            break;
          case h:
            m = R / e;
            break;
          default:
            m = R;
        }
        return n ? m : g.a(m);
      }, a.daysInMonth = function() {
        return this.endOf(A).$D;
      }, a.$locale = function() {
        return T[this.$L];
      }, a.locale = function(o, l) {
        if (!o)
          return this.$L;
        var n = this.clone(), m = K(o, l, !0);
        return m && (n.$L = m), n;
      }, a.clone = function() {
        return g.w(this.$d, this);
      }, a.toDate = function() {
        return new Date(this.valueOf());
      }, a.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, a.toISOString = function() {
        return this.$d.toISOString();
      }, a.toString = function() {
        return this.$d.toUTCString();
      }, p;
    }(), dt = nt.prototype;
    return x.prototype = dt, [["$ms", d], ["$s", h], ["$m", y], ["$H", u], ["$W", v], ["$M", A], ["$y", $], ["$D", w]].forEach(function(p) {
      dt[p[1]] = function(a) {
        return this.$g(a, p[0], p[1]);
      };
    }), x.extend = function(p, a) {
      return p.$i || (p(a, nt, x), p.$i = !0), x;
    }, x.locale = K, x.isDayjs = j, x.unix = function(p) {
      return x(1e3 * p);
    }, x.en = T[H], x.Ls = T, x.p = {}, x;
  });
})(St);
var Dr = St.exports;
const ot = /* @__PURE__ */ ut(Dr);
var $t = { exports: {} };
(function(r, t) {
  (function(e, s) {
    r.exports = s();
  })(ct, function() {
    var e = "minute", s = /[+-]\d\d(?::?\d\d)?/g, i = /([+-]|\d\d)/g;
    return function(d, h, y) {
      var u = h.prototype;
      y.utc = function(c) {
        var S = { date: c, utc: !0, args: arguments };
        return new h(S);
      }, u.utc = function(c) {
        var S = y(this.toDate(), { locale: this.$L, utc: !0 });
        return c ? S.add(this.utcOffset(), e) : S;
      }, u.local = function() {
        return y(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var v = u.parse;
      u.parse = function(c) {
        c.utc && (this.$u = !0), this.$utils().u(c.$offset) || (this.$offset = c.$offset), v.call(this, c);
      };
      var N = u.init;
      u.init = function() {
        if (this.$u) {
          var c = this.$d;
          this.$y = c.getUTCFullYear(), this.$M = c.getUTCMonth(), this.$D = c.getUTCDate(), this.$W = c.getUTCDay(), this.$H = c.getUTCHours(), this.$m = c.getUTCMinutes(), this.$s = c.getUTCSeconds(), this.$ms = c.getUTCMilliseconds();
        } else
          N.call(this);
      };
      var A = u.utcOffset;
      u.utcOffset = function(c, S) {
        var O = this.$utils().u;
        if (O(c))
          return this.$u ? 0 : O(this.$offset) ? A.call(this) : this.$offset;
        if (typeof c == "string" && (c = function(H) {
          H === void 0 && (H = "");
          var T = H.match(s);
          if (!T)
            return null;
          var U = ("" + T[0]).match(i) || ["-", 0, 0], j = U[0], K = 60 * +U[1] + +U[2];
          return K === 0 ? 0 : j === "+" ? K : -K;
        }(c), c === null))
          return this;
        var D = Math.abs(c) <= 16 ? 60 * c : c, L = this;
        if (S)
          return L.$offset = D, L.$u = c === 0, L;
        if (c !== 0) {
          var F = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
          (L = this.local().add(D + F, e)).$offset = D, L.$x.$localOffset = F;
        } else
          L = this.utc();
        return L;
      };
      var _ = u.format;
      u.format = function(c) {
        var S = c || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return _.call(this, S);
      }, u.valueOf = function() {
        var c = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * c;
      }, u.isUTC = function() {
        return !!this.$u;
      }, u.toISOString = function() {
        return this.toDate().toISOString();
      }, u.toString = function() {
        return this.toDate().toUTCString();
      };
      var $ = u.toDate;
      u.toDate = function(c) {
        return c === "s" && this.$offset ? y(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : $.call(this);
      };
      var w = u.diff;
      u.diff = function(c, S, O) {
        if (c && this.$u === c.$u)
          return w.call(this, c, S, O);
        var D = this.local(), L = y(c).local();
        return w.call(D, L, S, O);
      };
    };
  });
})($t);
var Lr = $t.exports;
const Ir = /* @__PURE__ */ ut(Lr);
var Ct = { exports: {} };
(function(r, t) {
  (function(e, s) {
    r.exports = s();
  })(ct, function() {
    var e = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, s = {};
    return function(i, d, h) {
      var y, u = function(_, $, w) {
        w === void 0 && (w = {});
        var c = new Date(_), S = function(O, D) {
          D === void 0 && (D = {});
          var L = D.timeZoneName || "short", F = O + "|" + L, H = s[F];
          return H || (H = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: O, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: L }), s[F] = H), H;
        }($, w);
        return S.formatToParts(c);
      }, v = function(_, $) {
        for (var w = u(_, $), c = [], S = 0; S < w.length; S += 1) {
          var O = w[S], D = O.type, L = O.value, F = e[D];
          F >= 0 && (c[F] = parseInt(L, 10));
        }
        var H = c[3], T = H === 24 ? 0 : H, U = c[0] + "-" + c[1] + "-" + c[2] + " " + T + ":" + c[4] + ":" + c[5] + ":000", j = +_;
        return (h.utc(U).valueOf() - (j -= j % 1e3)) / 6e4;
      }, N = d.prototype;
      N.tz = function(_, $) {
        _ === void 0 && (_ = y);
        var w = this.utcOffset(), c = this.toDate(), S = c.toLocaleString("en-US", { timeZone: _ }), O = Math.round((c - new Date(S)) / 1e3 / 60), D = h(S, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(15 * -Math.round(c.getTimezoneOffset() / 15) - O, !0);
        if ($) {
          var L = D.utcOffset();
          D = D.add(w - L, "minute");
        }
        return D.$x.$timezone = _, D;
      }, N.offsetName = function(_) {
        var $ = this.$x.$timezone || h.tz.guess(), w = u(this.valueOf(), $, { timeZoneName: _ }).find(function(c) {
          return c.type.toLowerCase() === "timezonename";
        });
        return w && w.value;
      };
      var A = N.startOf;
      N.startOf = function(_, $) {
        if (!this.$x || !this.$x.$timezone)
          return A.call(this, _, $);
        var w = h(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return A.call(w, _, $).tz(this.$x.$timezone, !0);
      }, h.tz = function(_, $, w) {
        var c = w && $, S = w || $ || y, O = v(+h(), S);
        if (typeof _ != "string")
          return h(_).tz(S);
        var D = function(T, U, j) {
          var K = T - 60 * U * 1e3, x = v(K, j);
          if (U === x)
            return [K, U];
          var g = v(K -= 60 * (x - U) * 1e3, j);
          return x === g ? [K, x] : [T - 60 * Math.min(x, g) * 1e3, Math.max(x, g)];
        }(h.utc(_, c).valueOf(), O, S), L = D[0], F = D[1], H = h(L).utcOffset(F);
        return H.$x.$timezone = S, H;
      }, h.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, h.tz.setDefault = function(_) {
        y = _;
      };
    };
  });
})(Ct);
var Br = Ct.exports;
const Nr = /* @__PURE__ */ ut(Br);
var xt = { exports: {} };
(function(r, t) {
  (function(e, s) {
    r.exports = s();
  })(ct, function() {
    return function(e, s, i) {
      s.prototype.isBetween = function(d, h, y, u) {
        var v = i(d), N = i(h), A = (u = u || "()")[0] === "(", _ = u[1] === ")";
        return (A ? this.isAfter(v, y) : !this.isBefore(v, y)) && (_ ? this.isBefore(N, y) : !this.isAfter(N, y)) || (A ? this.isBefore(v, y) : !this.isAfter(v, y)) && (_ ? this.isAfter(N, y) : !this.isBefore(N, y));
      };
    };
  });
})(xt);
var Hr = xt.exports;
const Er = /* @__PURE__ */ ut(Hr);
ot.extend(Ir);
ot.extend(Nr);
ot.tz.setDefault("Asia/Seoul");
ot.extend(Er);
const kt = ot.tz, Or = (r, t) => {
  const e = Pt, s = kt().isBefore("2024-08-01 00:00");
  let i = e.map((h) => I(b({}, h), {
    notice: h.name === "직무소개" && s
  }));
  if (t.jobs && (i = i.map((h) => Rr(h, t.jobs))), !r)
    return i;
  const d = i.findIndex((h) => h.name === "타임라인");
  return i[d].name = "맞춤피드", i;
};
function Rr(r, t) {
  if (r.name === "답변하기")
    return r;
  const e = r.path.includes("?") ? "&" : "?";
  return I(b({}, r), {
    path: `${r.path}${e}jobs=${t}`
  });
}
const Tr = (r) => typeof r == "object" && !Array.isArray(r) && r !== null ? !(r.name === null && r.profileImage === null) : !1;
const Pr = {
  name: "ComentoHeader",
  mixins: [st, W],
  props: {
    userInfo: {
      type: Object,
      default: () => {
      }
    },
    isTransparent: {
      type: Boolean,
      default: !1
    },
    isScrollTop: {
      type: Boolean,
      default: !1
    },
    baseUrl: {
      type: String,
      required: !0
    },
    autocompleteList: {
      type: Array,
      default: () => []
    },
    recentKeyword: {
      type: Array,
      default: () => []
    },
    popularKeyword: {
      type: Array,
      default: () => []
    },
    bookmarkCount: {
      type: Number,
      default: 0
    },
    notificationCount: {
      type: Number,
      default: 0
    },
    noSubHeader: {
      type: Boolean,
      default: !1
    },
    topBarType: {
      type: String,
      default: "default"
    },
    topBarActions: {
      type: Array,
      default: null
    },
    topBarTitle: {
      type: String,
      default: ""
    },
    searchKeyword: {
      type: String,
      default: ""
    },
    withAlert: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      showSearchDropdown: !1,
      activeMainMenuIndex: -1,
      isSubHeaderVisible: !0,
      lastScrollY: 0,
      isTransparentHeader: !1,
      unsubscribe: null
    };
  },
  computed: I(b({}, J(["header", "keywords"])), {
    currentMainMenuIndex() {
      return [this.isCommunity, this.isClassMenu, this.isCareerMenu, this.isMyPage].findIndex(
        (r) => r
      );
    },
    externshipSubHeaders() {
      const r = [...Ft];
      return kt().isBetween("2023-05-26", "2023-06-11", "day", []) && r.push(Kt), r;
    },
    classSubHeaders() {
      return [...Ut];
    },
    subHeaderMenus() {
      var s;
      const r = this.activeMainMenuIndex > -1;
      if (this.isSearch && !r)
        return this.searchMenuSubHeader;
      const t = r ? this.activeMainMenuIndex : this.currentMainMenuIndex;
      return ((s = [
        Or(Tr(this.userInfo), this.route.query),
        this.classSubHeaders,
        this.externshipSubHeaders
      ][t]) != null ? s : []).map((i, d) => I(b({}, i), {
        active: d === this.currentSubMenuIndex,
        anchor: i.anchor ? i.anchor : !this.isNuxt
      }));
    },
    searchMenuSubHeader() {
      const { path: r, query: t, params: e } = this.route, s = ht(e.keyword), i = (d) => {
        var u, v;
        let h = b({}, t);
        Object.prototype.hasOwnProperty.call(this.getSearchParams(d.product), "sort") ? h.sort = (u = this.getSearchParams(d.product)) == null ? void 0 : u.sort : delete h.sort, Object.prototype.hasOwnProperty.call(this.getSearchParams(d.product), "category") ? h.category = (v = this.getSearchParams(d.product)) == null ? void 0 : v.category : Object.prototype.hasOwnProperty.call(t, "category") && delete h.category;
        const y = _t(h) ? "" : `?${new URLSearchParams(h).toString()}`;
        return `${d.path}/${s}${y}`;
      };
      return Tt.map((d) => I(b({}, d), {
        path: i(d),
        active: r.startsWith(d.path)
      }));
    },
    currentSubMenuIndex() {
      if (this.activeMainMenuIndex > -1 && this.activeMainMenuIndex !== this.currentMainMenuIndex)
        return -1;
      let t = [];
      return this.isCommunity && (t = [this.isCommunityTimeline, this.isCommunityQna, this.isJobWiki, this.isAnswer]), this.isClassMenu && (t = [
        this.isEduMenu,
        this.isKDigitalMenu,
        this.isPt,
        this.isPathMenu,
        this.isVodMenu,
        this.isTrainingMenu
      ]), this.isCareerMenu && (t = [this.isDreamverseMenu, this.isExternshipMenu, this.isRecruitMenu]), t.findIndex((e) => e);
    },
    fakeHeaderClasses() {
      return b({
        "no-sub": this.noSubHeader || (this.currentMainMenuIndex === -1 || this.currentMainMenuIndex >= 3) && !this.isSearch,
        none: this.header.transparent
      }, this.withAlertClass);
    },
    currentHeaderHeight() {
      const r = this.withAlert ? this.isMobileView ? 64 : 56 : 0, t = this.isMobileView ? 52 : 69, e = this.subHeaderMenus.length > 0 ? 44 : 0;
      return r + t + e;
    },
    keyword() {
      const { params: r, query: t, name: e } = this.route;
      return e === Y.SEARCH_LIST ? r.keyword || r.product : t.query || r.keyword;
    },
    sync_searchKeyword: {
      get() {
        return this.keywords.search;
      },
      set(r) {
        const t = decodeURIComponent(r);
        this.$store.commit("_commonComponents/setKeywords", I(b({}, this.keywords), {
          search: t
        }));
      }
    },
    searchInputPlaceholder() {
      return this.isAnswer ? "검색어를 입력해주세요." : this.isCommunity || this.route.path.startsWith(`${lt.SEARCH}/${M.COMMUNITY}`) || this.route.name === Y.INDEX ? "커리어 고민이 있나요?" : "관심 직무를 입력해보세요.";
    },
    isSearchSubHeader() {
      return this.subHeaderMenus === this.searchMenuSubHeader;
    },
    logoUrl() {
      const r = () => this.isEduDetail ? "/edu" : this.isPt ? "/class/pt" : this.isVodDetail || this.isClassVodDetail ? "/vod" : "/?index";
      return this.isNuxt ? r() : this.baseUrl + r();
    },
    withAlertClass() {
      return { "with-alert": this.withAlert };
    },
    mainHeaders() {
      return Rt.map((r) => I(b({}, r), {
        nuxt: this.isNuxt && r.nuxt
      }));
    }
  }),
  watch: {
    route: {
      handler() {
        typeof window != "undefined" && window.removeEventListener("scroll", this.onScroll), this.isSubHeaderVisible = !this.noSubHeader, setTimeout(() => {
          typeof window != "undefined" && window.addEventListener("scroll", this.onScroll);
        }, 500);
      },
      immediate: !0
    },
    isSearch() {
      this.isSearch && this.setInitialSearchKeyword();
    },
    $props: {
      handler() {
        this.syncProps(this.$props);
      },
      immediate: !0,
      deep: !0
    },
    sync_searchKeyword(r) {
      const t = decodeURIComponent(r);
      this.$emit("update:searchKeyword", t);
    },
    showSearchDropdown(r) {
      this.$emit("show-search-dropdown", r);
    },
    isSubHeaderVisible: {
      handler(r) {
        this.$store.commit("_commonComponents/setIsSubHeaderAppear", r);
      },
      immediate: !0
    }
  },
  created() {
    this.isSubHeaderVisible = !this.noSubHeader;
  },
  mounted() {
    this.setInitialSearchKeyword(), this.lastScrollY = window.scrollY, window.addEventListener("scroll", this.onScroll), this.unsubscribe = this.$store.subscribeAction((r) => {
      const { type: t, payload: e } = r, s = t.split("/")[1];
      s === "logout" ? this.$emit("logout") : s === "clickNoti" ? this.$emit("click-noti") : s === "removeRecentKeyword" ? (this.$emit("remove-recent-keyword", e), this.showSearchDropdown = !0) : s === "search" ? this.doSearch(e) : s === "openSearch" && this.$emit("open-search");
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll), this.unsubscribe();
  },
  methods: I(b({}, X(["syncProps"])), {
    onScroll() {
      const r = this.lastScrollY > window.scrollY ? "up" : "down";
      this.lastScrollY = window.scrollY, this.$store.commit("_commonComponents/setHeader", {
        transparent: this.isTransparent && window.scrollY < this.currentHeaderHeight
      }), !(this.isSubHeaderVisible && window.scrollY < this.currentHeaderHeight || this.noSubHeader) && (this.isSubHeaderVisible = r === "up");
    },
    mouseLeaveHeader() {
      this.noSubHeader && (this.isSubHeaderVisible = !1), setTimeout(() => {
        this.updateNav(-1);
      }, 100);
    },
    mouseEnterHeader() {
      this.isSubHeaderVisible = !0;
    },
    updateNav(r) {
      this.activeMainMenuIndex = r, r !== -1 && this.mouseEnterHeader();
    },
    back() {
      history.back();
    },
    /**
     * searchTopBar 뒤로가기 버튼 눌렀을 때 발동하는 이벤트
     * from이 있으면 from 페이지로 보내고, 없으면 이전 페이지로 보내기
     */
    goFromOrBack() {
      const { from: r, legacy: t } = this.route.query;
      return r ? t ? location.href = r : this.router.push(r) : this.back();
    },
    setInitialSearchKeyword() {
      !this.searchKeyword && this.keyword && (this.sync_searchKeyword = this.keyword);
    },
    /**
     * @param name: route name 또는 product(community, edu 등)
     */
    getSearchParams(r) {
      return this.isCommunity || r === M.COMMUNITY ? {
        where: M.COMMUNITY,
        sort: rt.RELEVANCE,
        category: 0
      } : this.isEduMenu || this.isPathMenu || this.isClassHome || r === M.EDU ? {
        where: M.EDU,
        sort: rt.RELEVANCE
      } : this.isVodMenu || r === M.VOD ? {
        where: M.VOD,
        sort: rt.RELEVANCE
      } : this.isPt || r === M.CLASS_PT ? {
        where: M.CLASS_PT,
        sort: rt.RELEVANCE
      } : this.isAnswer || r === M.ANSWER ? {
        where: M.ANSWER,
        sort: rt.RELEVANCE
      } : {};
    },
    getSearchUrl({ name: r, query: t, path: e }, s, i) {
      let d = {};
      Object.prototype.hasOwnProperty.call(this.getSearchParams(r), "where") && (d.where = this.getSearchParams(r).where), Object.prototype.hasOwnProperty.call(t, "from") ? d.from = t.from : this.isMobileView && r !== Y.SEARCH_LIST && (d.from = e), Object.prototype.hasOwnProperty.call(t, "sort") && (d.sort = t.sort);
      const h = _t(d) ? "" : `?${new URLSearchParams(d).toString()}`;
      return `${lt.SEARCH}/${i}/${s}${h}`;
    },
    doSearch({ keyword: r, searchType: t }) {
      r && (this.$emit("search", { searchType: t, keyword: ht(r).trim() }), this.closeSearchDropdown(), this.goSearchPage(ht(r)));
    },
    goSearchPage(r) {
      const { name: t, params: e } = this.route;
      if (t.startsWith(Y.COMMUNITY_LOUNGE))
        return this.router.push(`${lt.LOUNGE}?query=${r}`);
      const i = (() => {
        const h = t.startsWith(Y.ANSWER) || t === Y.SEARCH_LIST && e.product === M.ANSWER, y = t === Y.SEARCH_LIST && e.product === M.COMMUNITY, u = t === Y.SEARCH_LIST && e.product === M.EDU, v = t === Y.SEARCH_LIST && e.product === M.CLASS_PT, N = t === Y.SEARCH_LIST && e.product === M.VOD;
        return h ? M.ANSWER : y ? M.COMMUNITY : u ? M.EDU : v ? M.CLASS_PT : N ? M.VOD : M.INDEX;
      })();
      let d = this.getSearchUrl(this.route, r, i);
      if (i === M.ANSWER) {
        this.router.push(d);
        return;
      }
      window.location.href = d;
    },
    autocomplete(r) {
      this.$emit("autocomplete", r);
    },
    emitClickSearchInputForMobile() {
      this.$emit("click-search-input-for-mobile");
    },
    openSearchDropdown() {
      this.showSearchDropdown = !0;
    },
    closeSearchDropdown() {
      this.showSearchDropdown = !1;
    }
  }),
  components: {
    HeaderCore: Ar,
    HeaderInfoSection: bt
  }
};
var Ur = function() {
  var t = this, e = t._self._c;
  return e("div", t._g({ staticClass: "header-wrapper" }, t.isMobileView ? {} : { mouseleave: t.mouseLeaveHeader }), [t.isMobileView ? [t.isSearch ? e("c-search-top-bar", { class: t.withAlertClass, attrs: { "is-transparent": t.header.transparent, keyword: t.sync_searchKeyword, "show-dropdown": t.showSearchDropdown, placeholder: t.searchInputPlaceholder }, on: { "update:keyword": function(s) {
    t.sync_searchKeyword = s;
  }, "update:showDropdown": function(s) {
    t.showSearchDropdown = s;
  }, "update:show-dropdown": function(s) {
    t.showSearchDropdown = s;
  }, search: t.doSearch, "click-button": t.goFromOrBack, autocomplete: t.autocomplete, "click-search-input": t.emitClickSearchInputForMobile } }) : e("c-top-bar", { attrs: { "is-transparent": t.header.transparent, type: t.topBarType, title: t.topBarTitle, "with-alert": t.withAlert, "logo-url": t.logoUrl }, on: { "click-backward": t.back }, scopedSlots: t._u([{ key: "actions", fn: function() {
    return [e("HeaderInfoSection", { on: { "show-edu-filter": function(s) {
      return t.$emit("show-edu-filter");
    } }, scopedSlots: t._u([{ key: "top-bar", fn: function() {
      return [t._t("top-bar")];
    }, proxy: !0 }], null, !0) })];
  }, proxy: !0 }], null, !1, 3558317618) })] : [e("HeaderCore", { attrs: { "activated-menu": t.currentMainMenuIndex, "hovered-menu": t.activeMainMenuIndex, items: t.mainHeaders, "search-placeholder": t.searchInputPlaceholder, "show-dropdown": t.showSearchDropdown, "logo-url": t.logoUrl }, on: { "update:showDropdown": function(s) {
    t.showSearchDropdown = s;
  }, "update:show-dropdown": function(s) {
    t.showSearchDropdown = s;
  }, "update-nav": t.updateNav, search: t.doSearch }, scopedSlots: t._u([{ key: "before-popular-list", fn: function() {
    return [t._t("before-popular-list")];
  }, proxy: !0 }, { key: "banner", fn: function() {
    return [t._t("banner")];
  }, proxy: !0 }], null, !0) })], !t.isMobileView || !t.noSubHeader ? e("c-sub-header", { attrs: { "is-appear": t.isSubHeaderVisible, "is-scroll-top": t.isScrollTop, "is-mobile-view": t.isMobileView, "is-search": t.isSearchSubHeader, "is-transparent": t.header.transparent, items: t.subHeaderMenus, "with-alert": t.withAlert } }) : t._e(), e("div", { staticClass: "fake-header", class: t.fakeHeaderClasses })], 2);
}, Kr = [], Fr = /* @__PURE__ */ k(
  Pr,
  Ur,
  Kr,
  !1,
  null,
  "c1a25065",
  null,
  null
);
const hs = Fr.exports;
const Vr = {
  name: "EduListFilterActionButton",
  props: {
    hasFilter: {
      type: Boolean,
      default: !1
    }
  },
  components: {
    TopBarActionButton: it
  }
};
var Wr = function() {
  var t = this, e = t._self._c;
  return e("TopBarActionButton", [e("c-icon-button", { attrs: { "icon-name": "IconFilterLargeLine", color: t.hasFilter ? "primary" : "gray400" } })], 1);
}, jr = [], Yr = /* @__PURE__ */ k(
  Vr,
  Wr,
  jr,
  !1,
  null,
  "f019a8d6",
  null,
  null
);
const ds = Yr.exports;
const zr = {
  name: "BottomNavBarButton",
  props: {
    icon: {
      type: String,
      required: !0
    },
    active: {
      type: Boolean,
      default: !1
    }
  },
  computed: {
    color() {
      return {
        icon: this.active ? "primary" : "gray500",
        text: this.active ? "primary" : "gray600"
      };
    }
  }
};
var qr = function() {
  var t = this, e = t._self._c;
  return e("div", { staticClass: "bottom-nav-bar-button" }, [e("c-icon", { attrs: { name: t.icon, color: t.color.icon } }), e("c-typography", { staticClass: "mt-2", attrs: { type: "caption2", color: t.color.text } }, [t._t("default")], 2)], 1);
}, Jr = [], Qr = /* @__PURE__ */ k(
  zr,
  qr,
  Jr,
  !1,
  null,
  "091716ff",
  null,
  null
);
const Gr = Qr.exports;
const Zr = {
  name: "BottomNav",
  mixins: [st],
  computed: {
    bottomNavs() {
      return [
        {
          name: "커뮤니티",
          path: "/job-questions",
          icon: "IconMentoringLargeLine",
          active: this.isCommunity,
          anchor: !0
        },
        {
          name: "클래스",
          path: "/edu",
          icon: "IconClassLargeLine",
          active: this.isClassMenu,
          anchor: !1
        },
        {
          name: "채용",
          path: "/career/recruit",
          icon: "IconBusinessCaseLargeLine",
          active: this.isCareerMenu,
          anchor: !0
        },
        {
          name: "마이페이지",
          path: "/mypage",
          icon: "IconProfileLargeLine",
          active: this.isMyPage,
          anchor: !0
        }
      ];
    }
  },
  components: { CustomNuxtLink: q, BottomNavBarButton: Gr }
};
var Xr = function() {
  var t = this, e = t._self._c;
  return e("nav", { staticClass: "bottom-nav" }, [e("c-divider"), e("ul", { staticClass: "bottom-nav-list" }, t._l(t.bottomNavs, function(s, i) {
    return e("li", { key: `bottom-navs-${i}` }, [e("CustomNuxtLink", { attrs: { to: s.path, nuxt: s.anchor } }, [e("BottomNavBarButton", { attrs: { icon: s.icon, active: s.active } }, [t._v(t._s(s.name))])], 1)], 1);
  }), 0)], 1);
}, ts = [], es = /* @__PURE__ */ k(
  Zr,
  Xr,
  ts,
  !1,
  null,
  "cf332768",
  null,
  null
);
const ps = es.exports;
const rs = {
  name: "SearchFullscreenModal",
  mixins: [st],
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    recentKeywords: {
      type: Array,
      default: () => []
    },
    popularKeywords: {
      type: Array,
      default: () => []
    },
    autocompleteList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      mobileKeyword: ""
    };
  },
  computed: {
    typographyInfo() {
      return {
        type: "body2",
        color: "gray800",
        fontWeight: 600
      };
    },
    placeholder() {
      return this.isAnswer ? "검색어를 입력해주세요." : this.isCommunityMenu ? "커리어 고민이 있나요?" : "관심 직무를 입력해보세요.";
    },
    directionForRoute() {
      return this.isSearch ? "none" : "left";
    }
  },
  watch: {
    show(r) {
      var t;
      r && (this.mobileKeyword = (t = this.route.params.keyword) != null ? t : "", this.$nextTick(() => {
        this.$refs.searchTopBar.$refs.searchInput.$refs.searchInput.focus();
      }));
    },
    mobileKeyword() {
      this.emitDebouncedAutocompleteList(this.mobileKeyword);
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    emitDebouncedAutocompleteList(r) {
      this.$emit("debounced-autocomplete-list", r);
    },
    searchRecentKeyword(r) {
      this.doSearchKeyword(r, "recent");
    },
    doSearchKeyword(r, t) {
      this.mobileKeyword = r, this.$emit("search", { keyword: r, searchType: t });
    },
    searchPopularKeyword(r) {
      this.doSearchKeyword(r, "popular");
    },
    searchAutocomplete({ keyword: r, searchType: t }) {
      this.doSearchKeyword(r, t);
    },
    emitRemoveRecentKeyword({ index: r }) {
      this.$emit("remove-recent-keyword", r);
    }
  },
  components: {
    RecentSearchItem: wt,
    AutocompleteList: gt
  }
};
var ss = function() {
  var t = this, e = t._self._c;
  return e("c-fullscreen-modal", { attrs: { id: "search-fullscreen-modal", show: t.show, direction: t.directionForRoute }, on: { close: t.close }, scopedSlots: t._u([{ key: "content", fn: function() {
    return [e("c-search-top-bar", { ref: "searchTopBar", attrs: { keyword: t.mobileKeyword, placeholder: t.placeholder, "is-close": "" }, on: { "update:keyword": function(s) {
      t.mobileKeyword = s;
    }, search: function(s) {
      return t.doSearchKeyword(t.mobileKeyword, "typing");
    }, "click-button": t.close } }), e("c-divider", { staticClass: "mt-52", attrs: { color: "gray200" } }), e("c-new-grid", { staticClass: "my-16" }, [e("c-new-row", [e("c-new-col", [t.mobileKeyword.length === 0 ? [t.recentKeywords.length > 0 ? e("div", { staticClass: "mb-24" }, [e("c-typography", { staticClass: "mb-12", attrs: { type: t.typographyInfo.type, color: t.typographyInfo.color, "font-weight": t.typographyInfo.fontWeight } }, [t._v(" 최근 검색어 ")]), e("c-list", { attrs: { size: "small", spacing: "" } }, t._l(t.recentKeywords, function(s, i) {
      return e("RecentSearchItem", { key: `recent-keyword-${i}`, attrs: { keyword: s, index: i }, on: { "click-keyword": function(d) {
        return t.searchRecentKeyword(s);
      }, "remove-recent": function(d) {
        return t.emitRemoveRecentKeyword(i);
      } } });
    }), 1)], 1) : t._e()] : e("section", [e("AutocompleteList", { attrs: { "autocomplete-list": t.autocompleteList.filter((s, i) => i < 8), keyword: t.mobileKeyword }, on: { "click-autocomplete": t.searchAutocomplete } })], 1)], 2)], 1)], 1)];
  }, proxy: !0 }]) });
}, os = [], ns = /* @__PURE__ */ k(
  rs,
  ss,
  os,
  !1,
  null,
  "39a31609",
  null,
  null
);
const ms = ns.exports;
export {
  gt as AutocompleteList,
  Ie as AutocompleteListItem,
  ps as BottomNav,
  ls as ComentoFooter,
  hs as ComentoHeader,
  We as DropdownList,
  ds as EduListFilterActionButton,
  wt as RecentSearchItem,
  ms as SearchFullscreenModal,
  Jt as SlimFooter,
  yt as TOP_BAR_ACTIONS,
  ft as TOP_BAR_TYPES,
  us as installStore
};
